<DataGridView DataUrl="/Backend/Api/V2/Admin/Leistung/List" #Grid KeyProperty="key">
  <DataGridViewColumn field="name" header="Name" />
  <DataGridViewColumn field="kosten" header="Kosten" />
  <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Leistung">
        <ng-template #staticContent>
          <LeistungEdit [Key]="row?.key"></LeistungEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
    <ng-template #header>
      <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Leistung">
        <ng-template #staticContent>
          <LeistungEdit></LeistungEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
